import React from 'react';
import { InfoIcon, X, AlertTriangle, AlertCircle } from 'lucide-react';

type BannerVariant = 'info' | 'warning' | 'error';

interface IBannerProps {
  text: string;
  variant?: BannerVariant;
  action?: React.ReactNode;
  onClose?: () => void;
}

export const Banner = ({
  text,
  variant = 'info',
  action,
  onClose
}: IBannerProps) => {
  const variantStyles = {
    info: {
      container:
        'tw-rounded-lg tw-bg-blue-50 tw-p-2 tw-w-fit tw-max-w-2xl tw-font-sans',
      icon: InfoIcon,
      iconColor: '#1D4ED8',
      textColor: 'tw-text-[#1E40AF]',
      label: 'Info',
      closeButtonColor: 'tw-text-blue-600 hover:tw-text-blue-800'
    },
    warning: {
      container:
        'tw-rounded-lg tw-bg-yellow-50 tw-p-2 tw-w-fit tw-max-w-2xl tw-font-sans',
      icon: AlertTriangle,
      iconColor: '#D97706',
      textColor: 'tw-text-[#92400E]',
      label: 'Warning',
      closeButtonColor: 'tw-text-yellow-600 hover:tw-text-yellow-800'
    },
    error: {
      container:
        'tw-rounded-lg tw-bg-red-50 tw-p-2 tw-w-fit tw-max-w-2xl tw-font-sans',
      icon: AlertCircle,
      iconColor: '#DC2626',
      textColor: 'tw-text-[#991B1B]',
      label: 'Error',
      closeButtonColor: 'tw-text-red-600 hover:tw-text-red-800'
    }
  };

  const styles = variantStyles[variant];
  const IconComponent = styles.icon;

  return (
    <div className={styles.container}>
      <div className="tw-flex tw-items-center tw-justify-between">
        <div className="tw-flex tw-gap-2 tw-items-center">
          <IconComponent size={20} color={styles.iconColor} />
          <p className={`tw-text-sm ${styles.textColor} tw-font-normal`}>
            {text} {action}
          </p>
        </div>
        {onClose && (
          <button
            onClick={onClose}
            className={`tw-ml-4 ${styles.closeButtonColor} tw-font-sans`}
          >
            <X className="tw-size-5" />
          </button>
        )}
      </div>
    </div>
  );
};
